<div class="nw-navigation-bar__container" #navbar>
    <header class="nw-navigation-bar__container__content" #container>
        <nw-navigation-bar-carousel [items]="carouselItems"></nw-navigation-bar-carousel>

        <nav
            class="nw-navigation-bar__container__content__items"
            role="navigation"
            aria-label="Main navigation"
        >
            <a
                [href]="homeUrl"
                style="display: contents"
                data-test="logo-homepage"
                aria-label="Go back to homepage"
            >
                <nw-icon
                    class="nw-navigation-bar__container__content__items__logo"
                    [class.nw-navigation-bar__container__content__items__logo--is-link]="
                        !!homeUrl
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xml:space="preserve"
                        version="1.1"
                        viewBox="0 0 396.37 71.6"
                    >
                        <path
                            d="M79.27 18.43v5.99h.14c.81-2.11 2.24-3.8 4.31-5.08 2.06-1.28 4.33-1.92 6.8-1.92 2.42 0 4.45.31 6.09.94 1.64.63 2.95 1.51 3.94 2.66.99 1.14 1.68 2.55 2.09 4.21.4 1.66.61 3.52.61 5.59v22.35h-4.24V31.49c0-1.48-.13-2.86-.4-4.14s-.74-2.39-1.41-3.33c-.67-.94-1.58-1.68-2.73-2.22-1.14-.54-2.57-.81-4.27-.81-1.71 0-3.22.3-4.54.91-1.32.61-2.45 1.44-3.37 2.49-.92 1.05-1.64 2.31-2.15 3.77-.52 1.46-.8 3.04-.84 4.75v20.26h-4.24V18.43h4.21zM120.26 41.69c.43 1.64 1.11 3.11 2.05 4.41.94 1.3 2.13 2.38 3.57 3.23 1.44.85 3.16 1.28 5.18 1.28 3.1 0 5.52-.81 7.27-2.42 1.75-1.62 2.96-3.77 3.64-6.46h4.24c-.9 3.95-2.55 7-4.95 9.15-2.4 2.15-5.8 3.23-10.2 3.23-2.74 0-5.11-.48-7.1-1.45-2-.96-3.62-2.29-4.88-3.97-1.26-1.68-2.19-3.63-2.79-5.86-.61-2.22-.91-4.57-.91-7.03 0-2.29.3-4.53.91-6.73.61-2.2 1.54-4.16 2.79-5.89 1.26-1.73 2.88-3.12 4.88-4.17 2-1.05 4.36-1.58 7.1-1.58 2.78 0 5.16.56 7.14 1.68 1.97 1.12 3.58 2.59 4.81 4.41 1.23 1.82 2.12 3.9 2.66 6.26s.76 4.74.67 7.17h-26.72c0 1.52.21 3.1.64 4.74zm21-12.96c-.52-1.48-1.25-2.79-2.19-3.94-.94-1.14-2.09-2.06-3.43-2.76-1.35-.69-2.87-1.04-4.58-1.04-1.75 0-3.3.35-4.64 1.04-1.35.7-2.49 1.62-3.43 2.76-.94 1.14-1.69 2.47-2.26 3.97-.56 1.5-.93 3.04-1.11 4.61h22.48a15.05 15.05 0 0 0-.84-4.64zM173.13 18.43V22h-7.07v23.43c0 1.39.19 2.48.57 3.26.38.79 1.33 1.22 2.86 1.31 1.21 0 2.42-.07 3.64-.2v3.57c-.63 0-1.26.02-1.88.07-.63.04-1.26.07-1.88.07-2.83 0-4.8-.55-5.92-1.65-1.12-1.1-1.66-3.13-1.62-6.09V22h-6.06v-3.57h6.06V8h4.24v10.43h7.06zM187.52 18.43l8.88 29.75h.14l8.48-29.75h4.78l8.48 29.75h.13l8.88-29.75h4.51l-11.17 34.73H216l-8.55-29.21h-.13l-8.48 29.21h-4.64l-11.17-34.73h4.49zM244.04 41.69c.43 1.64 1.11 3.11 2.05 4.41.94 1.3 2.13 2.38 3.57 3.23 1.44.85 3.16 1.28 5.18 1.28 3.1 0 5.52-.81 7.27-2.42 1.75-1.62 2.96-3.77 3.64-6.46h4.24c-.9 3.95-2.55 7-4.95 9.15-2.4 2.15-5.8 3.23-10.2 3.23-2.74 0-5.11-.48-7.1-1.45-2-.96-3.62-2.29-4.88-3.97-1.26-1.68-2.19-3.63-2.79-5.86-.61-2.22-.91-4.57-.91-7.03 0-2.29.3-4.53.91-6.73.61-2.2 1.54-4.16 2.79-5.89 1.26-1.73 2.88-3.12 4.88-4.17 2-1.05 4.36-1.58 7.1-1.58 2.78 0 5.16.56 7.14 1.68 1.97 1.12 3.58 2.59 4.81 4.41 1.23 1.82 2.12 3.9 2.66 6.26s.76 4.74.67 7.17H243.4c0 1.52.21 3.1.64 4.74zm21-12.96c-.52-1.48-1.25-2.79-2.19-3.94-.94-1.14-2.09-2.06-3.43-2.76-1.35-.69-2.87-1.04-4.58-1.04-1.75 0-3.3.35-4.64 1.04-1.35.7-2.49 1.62-3.43 2.76-.94 1.14-1.69 2.47-2.26 3.97-.56 1.5-.93 3.04-1.11 4.61h22.48c-.05-1.61-.33-3.16-.84-4.64zM283.66 23.82c.72-1.48 1.69-2.69 2.93-3.63 1.23-.94 2.68-1.64 4.34-2.09 1.66-.45 3.5-.67 5.52-.67 1.53 0 3.05.15 4.58.44 1.53.29 2.9.84 4.11 1.65 1.21.81 2.2 1.94 2.96 3.4.76 1.46 1.14 3.36 1.14 5.69v18.44c0 1.71.83 2.56 2.49 2.56.49 0 .94-.09 1.35-.27v3.57c-.5.09-.93.16-1.31.2-.38.04-.86.07-1.45.07-1.08 0-1.94-.14-2.59-.44-.65-.29-1.16-.71-1.51-1.25-.36-.54-.6-1.18-.71-1.92-.11-.74-.17-1.56-.17-2.46h-.14c-.76 1.12-1.54 2.12-2.32 3-.79.88-1.66 1.61-2.63 2.19-.96.58-2.06 1.03-3.3 1.35-1.24.31-2.7.47-4.41.47-1.62 0-3.13-.19-4.54-.57-1.41-.38-2.65-.99-3.7-1.82-1.06-.83-1.88-1.88-2.49-3.16-.61-1.28-.91-2.79-.91-4.54 0-2.42.54-4.32 1.62-5.69s2.5-2.41 4.27-3.13c1.77-.72 3.77-1.22 5.99-1.51 2.22-.29 4.48-.57 6.76-.84.9-.09 1.68-.2 2.36-.34.67-.13 1.23-.37 1.68-.71.45-.34.8-.8 1.04-1.38.25-.58.37-1.35.37-2.29 0-1.44-.24-2.61-.71-3.53a5.593 5.593 0 0 0-1.95-2.19c-.83-.54-1.8-.91-2.9-1.11-1.1-.2-2.28-.3-3.53-.3-2.69 0-4.89.64-6.6 1.92-1.71 1.28-2.6 3.33-2.69 6.16h-4.24c.14-2.04.57-3.79 1.29-5.27zm21.2 10.37c-.27.49-.78.85-1.55 1.08-.76.23-1.44.38-2.02.47-1.79.31-3.65.59-5.55.84-1.91.25-3.65.62-5.22 1.11-1.57.49-2.86 1.2-3.87 2.12-1.01.92-1.51 2.23-1.51 3.94 0 1.08.21 2.03.64 2.86.43.83 1 1.55 1.72 2.15.72.61 1.55 1.07 2.49 1.38.94.31 1.91.47 2.9.47 1.62 0 3.16-.25 4.64-.74 1.48-.49 2.77-1.21 3.87-2.15s1.97-2.09 2.63-3.43c.65-1.35.98-2.87.98-4.58v-5.52h-.15zM356.88 18.43V22h-7.07v23.43c0 1.39.19 2.48.57 3.26.38.79 1.33 1.22 2.86 1.31 1.21 0 2.42-.07 3.64-.2v3.57c-.63 0-1.26.02-1.88.07-.63.04-1.26.07-1.88.07-2.83 0-4.8-.55-5.92-1.65-1.12-1.1-1.66-3.13-1.62-6.09V22h-6.06v-3.57h6.06V8h4.24v10.43h7.06zM372.4 5.11v19.32h.14c.81-2.11 2.24-3.8 4.31-5.08 2.06-1.28 4.33-1.92 6.8-1.92 2.42 0 4.45.31 6.09.94 1.64.63 2.95 1.51 3.94 2.66.99 1.14 1.68 2.55 2.09 4.21.4 1.66.61 3.52.61 5.59v22.35h-4.24V31.49c0-1.48-.13-2.86-.4-4.14s-.74-2.39-1.41-3.33c-.67-.94-1.58-1.68-2.73-2.22-1.14-.54-2.57-.81-4.27-.81-1.71 0-3.22.3-4.54.91-1.32.61-2.45 1.44-3.37 2.49-.92 1.05-1.64 2.31-2.15 3.77-.52 1.46-.8 3.04-.84 4.75v20.26h-4.24V5.11h4.21zM44.99 0v10.33h-8.87V0H22.48v10.33h-8.85V0H0v61.29h11.26V71.6h13.6V61.29h8.88V71.6h13.6V61.29H58.6V0H44.99zM11.26 58.91H2.38V2.38h8.88v56.53zm11.23 10.32h-8.87V12.7h8.87v56.53zm11.25-10.32h-8.88V2.38h8.88v56.53zm11.24 10.32h-8.87V12.7h8.87v56.53zm11.25-10.32h-8.88V2.38h8.88v56.53zM328.46 32.91v20.26h-4.24V5.11h4.24v27.8z"
                            fill="currentColor"
                        />
                    </svg> </nw-icon
            ></a>
            <svg width="0" height="0">
                <filter id="blur-and-scale" y="-50%" x="-50%" width="200%" height="200%">
                    <feGaussianBlur
                        in="SourceGraphic"
                        stdDeviation="10"
                        result="blurred"
                    />
                    <feComponentTransfer>
                        <feFuncA type="linear" slope="0.3" />
                    </feComponentTransfer>
                    <feComposite in="SourceGraphic" operator="over" />
                </filter>
            </svg>
            @if (!drawerOpen) {
                @for (item of navigationItems; track item.label) {
                    <!-- An item that only goes somewhere is a link, so the host's router and the
                         browser handle it; one that opens the submenu stays a button. -->
                    @if (item.path && !item.children?.length) {
                        <a
                            class="nw-navigation-bar__container__content__items__item"
                            [class.nw-navigation-bar__container__content__items__item--right]="
                                item.float === 'right'
                            "
                            [href]="item.path"
                            (click)="itemClickAndClose(item, $event)"
                            [nwAddAttributes]="item.attributes"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    itemContent;
                                    context: { $implicit: item }
                                "
                            ></ng-container>
                        </a>
                    } @else {
                        <button
                            class="nw-navigation-bar__container__content__items__item"
                            [class.nw-navigation-bar__container__content__items__item--right]="
                                item.float === 'right'
                            "
                            (click)="toggleSubMenu(item)"
                            [nwAddAttributes]="item.attributes"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    itemContent;
                                    context: { $implicit: item }
                                "
                            ></ng-container>
                        </button>
                    }
                }
            }
            <div
                class="nw-navigation-bar__container__content__items__actions"
                [class.nw-navigation-bar__container__content__items__actions--no-margin]="
                    hasRightMenuItem
                "
            >
                <ng-content select="[top]"></ng-content>

                @if ((sideMenuConfig?.items?.length ?? 0) > 0) {
                    <div
                        class="nw-navigation-bar__container__content__items__actions__mobile-toggle"
                    >
                        <button
                            (click)="setDrawerOpen(true)"
                            nw-icon-button
                            class="nw-navigation-bar__container__content__items__actions__mobile-toggle__button"
                            color="dark"
                            data-test="mobile-menu"
                            aria-label="Open menu"
                            [attr.aria-expanded]="drawerOpen"
                        >
                            <nw-icon>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill
                                    viewBox="0 0 22 18"
                                    width="100%"
                                    height="100%"
                                    style="display: block"
                                    preserveAspectRatio="xMidYMid meet"
                                    focusable="false"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M.5 1.5C.5.67 1.17 0 2 0h18c.83 0 1.5.67 1.5 1.5S20.83 3 20 3H2C1.17 3 .5 2.33.5 1.5ZM.5 9c0-.83.67-1.5 1.5-1.5h18c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H2C1.17 10.5.5 9.83.5 9Zm21 7.5c0 .83-.67 1.5-1.5 1.5H2c-.83 0-1.5-.67-1.5-1.5S1.17 15 2 15h18c.83 0 1.5.67 1.5 1.5Z"
                                    />
                                    @if (showBadge && !disableRootBadge) {
                                        <circle cx="20" cy="2" r="6" fill="#33d0f2" />
                                    }
                                </svg>
                            </nw-icon>
                        </button>
                    </div>
                }
            </div>
        </nav>

        @let closeSidePanel = closeSidePanel$ | async;
        @let closeDrawer = closeDrawer$ | async;
        @let rotate = rotate$ | async;

        @if (debouncedSubMenuOpen$ | async) {
            <nav
                class="nw-navigation-bar__container__content__submenu"
                [class.nw-navigation-bar__container__content__submenu--active]="
                    selectedNavigationItem && subMenuOpen
                "
                [style.maxWidth.px]="subMenuMaxWidth"
                role="navigation"
                aria-label="Child navigation"
            >
                <div
                    class="nw-navigation-bar__container__content__submenu__wrapper"
                    [style.display]="
                        ((selectedNavigationItem?.children | navigationCategories)
                            ?.length || -1) > 1
                            ? 'flex'
                            : undefined
                    "
                >
                    @for (
                        category of selectedNavigationItem?.children
                            | navigationCategories;
                        track $index
                    ) {
                        @if (category.category && category.category !== 'undefined') {
                            <div
                                class="nw-navigation-bar__container__content__submenu__category"
                            >
                                <div
                                    class="nw-navigation-bar__container__content__submenu__category__heading"
                                >
                                    {{ category.category }}
                                </div>
                                <div
                                    class="nw-navigation-bar__container__content__submenu__category__underline"
                                ></div>
                                @for (
                                    item of category?.navigationItems;
                                    track item.label
                                ) {
                                    <div
                                        class="nw-navigation-bar__container__content__submenu__item"
                                    >
                                        <a
                                            [href]="item.path"
                                            [nwAddAttributes]="item.attributes"
                                            (click)="itemClickAndClose(item, $event)"
                                            >{{ item.label }}
                                            @if (item.badge && item.badge.value) {
                                                <nw-pill
                                                    class="nw-navigation-bar__container__content__submenu__item__pill"
                                                    [nwAddAttributes]="
                                                        item?.badge?.attributes
                                                    "
                                                    >{{ item.badge.value }}</nw-pill
                                                >
                                            }
                                        </a>
                                    </div>
                                }
                            </div>
                        } @else {
                            @for (item of category?.navigationItems; track item.label) {
                                <div
                                    class="nw-navigation-bar__container__content__submenu__item"
                                >
                                    <a
                                        [href]="item.path"
                                        [nwAddAttributes]="item.attributes"
                                        (click)="itemClickAndClose(item, $event)"
                                        >{{ item.label }}</a
                                    >
                                    @if (item.badge && item.badge.value) {
                                        <nw-pill
                                            class="nw-navigation-bar__container__content__submenu__item__pill"
                                            [nwAddAttributes]="item?.badge?.attributes"
                                            >{{ item.badge.value }}</nw-pill
                                        >
                                    }
                                </div>
                            }
                        }
                    }
                </div>
                @if (selectedNavigationItem?.path) {
                    <div class="nw-navigation-bar__container__content__submenu__view-all">
                        <a
                            [href]="selectedNavigationItem?.path"
                            (click)="
                                !!selectedNavigationItem
                                    ? itemClickAndClose(selectedNavigationItem, $event)
                                    : {}
                            "
                            >View {{ selectedNavigationItem?.label?.toLowerCase() }}
                            <nw-icon
                                class="nw-navigation-bar__container__content__submenu__view-all__chevron"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 13 22"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                                    /></svg></nw-icon
                        ></a>
                    </div>
                }
            </nav>
        }
    </header>

    <div
        class="nw-navigation-bar__container__drawer"
        [class.nw-navigation-bar__container__drawer--open]="drawerOpen"
        (click)="onDrawerClick($event)"
    >
        <div class="nw-navigation-bar__container__drawer__close">
            <button nw-icon-button (click)="setDrawerOpen(false)" aria-label="Close menu">
                <nw-icon>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 15 16"
                        width="100%"
                        height="100%"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M14.56 3.06A1.502 1.502 0 0 0 12.435.935L7.5 5.876 2.56.942A1.502 1.502 0 0 0 .435 3.064L5.376 8 .442 12.94a1.502 1.502 0 0 0 2.123 2.124l4.936-4.94 4.94 4.935a1.502 1.502 0 0 0 2.124-2.123L9.624 8l4.935-4.94Z"
                        />
                    </svg>
                </nw-icon>
            </button>
        </div>
        @if (debouncedDrawerOpen$ | async) {
            <nw-side-menu
                class="nw-navigation-bar__container__drawer__menu padding-m"
                [menuConfig]="sideMenuConfig"
            ></nw-side-menu>
        }
        <div class="nw-navigation-bar__container__drawer__actions">
            <ng-content select="[side]"></ng-content>
        </div>
    </div>

    @if (drawerOpen) {
        <div
            class="nw-navigation-bar__container__backdrop"
            [style.display]="drawerOpen ? 'inherit' : 'none'"
            (click)="setDrawerOpen(false)"
            (keydown)="({})"
            tabindex="-1"
        ></div>
    }
</div>

<div [style.height.px]="spacerHeight()" #spacer></div>

<!-- Shared by the link and button forms of a top-level item above. -->
<ng-template #itemContent let-item>
    <div
        class="nw-navigation-bar__container__content__items__item__label"
        [class.nw-navigation-bar__container__content__items__item__label--inactive]="
            selectedNavigationItem !== item && subMenuOpen
        "
    >
        {{ item.label }}
        @if (item.badge && item.badge.value) {
            <nw-pill
                class="nw-navigation-bar__container__content__items__item__label__pill"
                [nwAddAttributes]="item?.badge?.attributes"
                >{{ item.badge.value }}</nw-pill
            >
        }
        @if (item.children?.length) {
            <nw-icon
                class="nw-navigation-bar__container__content__items__item__label__chevron"
                [class.nw-navigation-bar__container__content__items__item__label__chevron--open]="
                    selectedNavigationItem === item && subMenuOpen
                "
                ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 13 22"
                    width="100%"
                    height="100%"
                    style="display: block"
                    preserveAspectRatio="xMidYMid meet"
                    focusable="false"
                >
                    <path
                        fill="currentColor"
                        d="M12.06 9.94a1.502 1.502 0 0 1 0 2.124l-9 9a1.502 1.502 0 0 1-2.124-2.123L8.876 11 .942 3.06A1.502 1.502 0 0 1 3.064.935l9 9-.005.005Z"
                    />
                </svg>
            </nw-icon>
        }
    </div>

    <div
        class="nw-navigation-bar__container__content__items__item__indicator"
        [class.nw-navigation-bar__container__content__items__item__indicator--active]="
            item.active
        "
    ></div>
</ng-template>
